import type { MailboxInfo } from "owa-client-types";
import { type DatapointStatus, PerformanceCoreDatapoint } from "owa-analytics";

const PENDING_TTL_MS = 2 * 60 * 1000;

const pendingDatapoints = new Map<string, PerformanceCoreDatapoint>();

function setPendingDatapoint(itemId: string, dp: PerformanceCoreDatapoint): void {
    pendingDatapoints.set(itemId, dp);
    setTimeout(() => {
        pendingDatapoints.delete(itemId);
    }, PENDING_TTL_MS);
}

export function startOfflineSendE2EDatapoint(itemId: string, mailboxInfo: MailboxInfo): void {
    const dp = new PerformanceCoreDatapoint("MailComposeOfflineSendE2E", mailboxInfo);
    dp.addCustomData({ startedAt: Date.now(), itemId });
    setPendingDatapoint(itemId, dp);
}

export function logSendDatapointAfterAQ(itemId: string, itemExistsInOutbox: boolean): void {
    const dp = pendingDatapoints.get(itemId);
    if (dp) {
        dp.addCustomData({ acceptedByAQ: Date.now(), itemExistsInOutbox });
        if (!itemExistsInOutbox) {
            dp.end();
            pendingDatapoints.delete(itemId);
        }
    }
}

export function logSendDatapointAfterRowRemoved(itemId: string): void {
    const dp: PerformanceCoreDatapoint | undefined = pendingDatapoints.get(itemId);
    if (dp) {
        pendingDatapoints.delete(itemId);
        dp.addCustomData({ rowRemoved: Date.now() });
        dp.end();
    }
}

export function updateSendDatapointItemId(oldItemId: string, newItemId: string): void {
    if (oldItemId !== newItemId) {
        const dp = pendingDatapoints.get(oldItemId);
        if (dp) {
            pendingDatapoints.delete(oldItemId);
            setPendingDatapoint(newItemId, dp);
            dp.addCustomData({ oldItemId, updatedItemId: newItemId });
        }
    }
}

export function endSendDatapoint(itemId: string, status?: DatapointStatus, error?: Error): void {
    const dp = pendingDatapoints.get(itemId);
    if (dp) {
        if (status && error) {
            dp.endWithError(status, error);
        }
        else {
            dp.end();
        }
        pendingDatapoints.delete(itemId);
    }
}
